import { CarTaxiFront, Sparkles, Star } from "lucide-react";

export const NearbyTaxis = ({ drivers, selected, onSelect }) => (
  <div data-testid="nearby-taxis-panel" className="rounded-2xl border-2 border-slate-100 bg-white p-4">
    <div className="mb-2 flex items-center justify-between">
      <span className="text-xs font-bold uppercase tracking-widest text-slate-500">Taxis near you</span>
      <span className="text-xs text-slate-400" data-testid="nearby-taxis-count">{drivers.length} online</span>
    </div>
    <button
      type="button"
      data-testid="taxi-choice-auto"
      onClick={() => onSelect(null)}
      className={`mb-2 flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm transition-colors ${!selected ? "bg-blue-700 text-white" : "bg-slate-50 text-slate-700 hover:bg-slate-100"}`}
    >
      <Sparkles className="h-4 w-4" />
      <span className="flex-1 font-semibold">Nearest available driver</span>
      {drivers[0] && <span className="text-xs opacity-80">~{drivers[0].eta_min} min</span>}
    </button>
    <div className="max-h-48 space-y-1 overflow-y-auto">
      {drivers.slice(0, 8).map((d) => (
        <button
          type="button"
          key={d.driver_id}
          data-testid={`taxi-choice-${d.driver_id}`}
          onClick={() => onSelect(d)}
          className={`flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm transition-colors ${selected?.driver_id === d.driver_id ? "bg-amber-100 ring-2 ring-amber-400" : "hover:bg-slate-50"}`}
        >
          <CarTaxiFront className="h-4 w-4 text-blue-700" />
          <span className="min-w-0 flex-1">
            <span className="block truncate font-medium text-slate-900">#{d.taxi_no} · {d.name}</span>
            <span className="block truncate text-xs text-slate-500">{d.car} · {d.plate}</span>
          </span>
          {d.rating && <span className="flex items-center gap-0.5 text-xs text-amber-600"><Star className="h-3 w-3 fill-amber-400 text-amber-400" />{d.rating.toFixed(1)}</span>}
          <span className="w-16 text-right text-xs font-semibold text-slate-700">{d.km < 0.1 ? "nearby" : `${d.km} km`}</span>
        </button>
      ))}
      {drivers.length === 0 && <p className="px-1 py-2 text-xs text-slate-400">No taxis are sharing their location right now — your request will go to all online drivers.</p>}
    </div>
  </div>
);
